import React, { useState, useEffect } from "react";
import "./Navebar.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";
import { NavLink } from "react-router-dom";

function Navebar() {
  const [clicked, setclicked] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggle = () => {
    setclicked(!clicked);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        <NavLink to="/" className="logo-brand">
          <div className="logo-icon-wrapper">
            <img src="/new-logo.png" alt="XHT Icon" />
          </div>
          <div className="logo-text">
            <span className="brand-primary">Xperts</span>
            <span className="brand-accent">House Tech</span>
          </div>
        </NavLink>

        <div className={`nav-toggle ${clicked ? "active" : ""}`} onClick={toggle}>
          {clicked ? <RxCross2 /> : <GiHamburgerMenu />}
        </div>

        <div className={`nav-menu ${clicked ? "active" : ""}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink to="/" onClick={() => setclicked(false)}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" onClick={() => setclicked(false)}>
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/servicespage" onClick={() => setclicked(false)}>
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contactus" onClick={() => setclicked(false)}>
                Contact
              </NavLink>
            </li>
          </ul>

          <div className="nav-cta">
            <NavLink
              to="/contactus"
              className="btn-primary"
              onClick={() => setclicked(false)}
            >
              Get in Touch
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navebar;
